// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3779":"3eb5f8913b97900d","4112":"a3ede44e6a0beb25","7140":"a7423aeeee0005d7","8787":"a1e3a7d3afb0d21c","9287":"ed4f01c4e8c6f879"}[chunkId] + ".css";
};